'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dFeatures$0024 from "./presto.types$-Features$.js";
var $p;
/** @constructor */
function $c_Lpresto_DashboardPage$() {
}
export { $c_Lpresto_DashboardPage$ as $c_Lpresto_DashboardPage$ };
$p = $c_Lpresto_DashboardPage$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DashboardPage$;
/** @constructor */
function $h_Lpresto_DashboardPage$() {
}
export { $h_Lpresto_DashboardPage$ as $h_Lpresto_DashboardPage$ };
$h_Lpresto_DashboardPage$.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return 99649315;
});
$p.l = (function() {
  return "DashboardPage";
});
$p.r = (function() {
  return 0;
});
$p.s = (function() {
  return "DashboardPage";
});
$p.j = (function(n) {
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.dw = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_presto$002etypes$0024$002dFeatures$0024.$m_Lpresto_types$Features$().lH);
});
var $d_Lpresto_DashboardPage$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DashboardPage$, "presto.DashboardPage$", ({
  H7: 1,
  a2: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_DashboardPage$ as $d_Lpresto_DashboardPage$ };
var $n_Lpresto_DashboardPage$;
function $m_Lpresto_DashboardPage$() {
  if ((!$n_Lpresto_DashboardPage$)) {
    $n_Lpresto_DashboardPage$ = new $c_Lpresto_DashboardPage$();
  }
  return $n_Lpresto_DashboardPage$;
}
export { $m_Lpresto_DashboardPage$ as $m_Lpresto_DashboardPage$ };
//# sourceMappingURL=presto.-Dashboard-Page$.js.map
